import PageContainer from "@/pages/containers/page-container";
import { HcbbBackButton } from "@/pages/components/hcbb-cost-estimator/hcbb-back-button";
import { HcbbSearchForm } from "@/pages/components/hcbb-cost-estimator/hcbb-search-form";
import { HcbbRecentSearches } from "@/pages/components/hcbb-cost-estimator/hcbb-recent-searches";
import { HcbbHelpfulInfo } from "@/pages/components/hcbb-cost-estimator/hcbb-helpful-info";
import { useFeatureName } from "@/hooks/use-pageTitle";
import { useHcbbSearchReset } from "@/hooks/use-hcbb-cost-estimator";
import ScreenRouteNames from "@/constants/screen-route-names";

export const HcbbCostEstimatorSearchPage = () => {
  const featureName = useFeatureName();

  // Arriving here always starts a new search, however the member got here.
  useHcbbSearchReset();

  return (
    <PageContainer
      // This is the feature's entry point, so a history step back can land on
      // whatever screen the member arrived from — including the results page
      // they just left via this same button (a push, not a pop) — rather than
      // the dashboard. Send it to the dashboard explicitly instead.
      headerLeftContent={
        <HcbbBackButton to={`/${ScreenRouteNames.HOME.path}`} />
      }
      title={featureName}
    >
      <div className="space-y-8 p-6">
        <HcbbSearchForm />
        <HcbbRecentSearches />
        <HcbbHelpfulInfo />
      </div>
    </PageContainer>
  );
};
